<template>
    <div class="row">
        <div class="col-12">
            <h2 class="m-0 h1 text-uppercase">Completa tus datos</h2>
            <div class="subtitle h3 light mb-3 mb-lg-5">Completa la información necesaria para comprar tus entradas.</div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <template v-for="(abono, index) in this.datos_compradores">
                    <div :key="index">
                        <DatosAbonoComponent :abono="abono" :index="index" :descuentos="abono_seleccionado.descuentos" :tipos_abonos="[abono_seleccionado]" ></DatosAbonoComponent>
                    </div>
                </template>
                <div class="mt-4" v-if="documentacion_error">
                    <h4 class="text-danger">
                        Para poder continuar es necesario subir toda la documentacion solicitada.
                    </h4>
                </div>
                <div class="mt-4">
                    <button type="submit" class="button effect-button large-button"><span>CONTINUAR COMPRA</span></button>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
	import DatosAbonoComponent from '@/components/frontend/abonos/nuevo/DatosAbonoComponent';  

    export default {
        props: ['datos_compradores', 'abono_seleccionado'],
        data() {
            return {
                loading: false,
                documentacion_error: false,
            }
        },
        methods: {
        	async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    for (var i = 0; i < this.datos_compradores.length; i++) {
                        if(this.datos_compradores[i].precio) {
                            if(!this.datos_compradores[i].precio.solicitar_documentacion) {
                                this.documentacion_error = false;
                            } else if(this.datos_compradores[i].documentaciones && this.datos_compradores[i].documentaciones.length > 0) {
                                this.documentacion_error = false;
                            } else {
                                this.documentacion_error = true;
                                break;
                            }

                        } else {
                            this.documentacion_error = false;
                        }
                    }

                    if(!this.documentacion_error) {
                        this.terminar();
                    }

                } else {
                    this.scrollTo('.is-invalid');
                }
            },
            terminar() {
            	this.$emit('terminar');
            },
            volver() {
            	this.$emit('volver');
            }
        },
        components: {
        	DatosAbonoComponent
        }
    }
</script>
